import {Outlet} from 'react-router-dom'
import {AccessesTabs} from '@/features/accesses/components/accesses-tabs/AccessesTabs'
import {Fragment} from 'react/jsx-runtime'

export const AccessesLayout = () => {
    return (
        <Fragment>
            <AccessesTabs />
            <Outlet />
        </Fragment>
    )
}
